(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    

function applyEnfafCartDiscount(details) {
  const field = details.querySelector('cart-discount-field');
  const input = field?.querySelector('input:not([type="hidden"])');
  if (!input || !input.value.trim() || field.getAttribute('aria-busy') === 'true') return;
  input.blur();
  if (field.getAttribute('aria-busy') !== 'true') {
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('#cart-drawer [data-enfaf-apply-discount]');
  if (button) applyEnfafCartDiscount(button.closest('details'));
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' || !(event.target instanceof Element)) return;
  const input = event.target.closest('#cart-drawer cart-discount-field input:not([type="hidden"])');
  if (!input) return;
  event.preventDefault();
  applyEnfafCartDiscount(input.closest('details'));
});


  } catch(e) { console.error(e); }
})();
})();
